import { Grid, Stack, Typography } from '@mui/material'
import Label from 'components/Label'
import React from 'react'
import { StyledSpan } from '../../styles'

type FieldProps = {
  label: string
  text?: string
  fontWeight: string | number
}

export const Field: React.FC<FieldProps> = ({ label, text, fontWeight }) => {
  return text && text !== '' ? (
    <Grid item xs={12}>
      <Typography variant='body1' sx={{ fontSize: 14 }}>
        <b>{label}</b> <span style={{ fontWeight }}>{text}</span>
      </Typography>
    </Grid>
  ) : null
}
